import { AxiosResponse } from 'axios';
import { PortCollection } from 'types/Port';
import { objectKeysToCamelCase, objectKeysToSnakeCase } from 'utils/common';
import axiosWithToken from './axios-with-token';

export enum PortCollectionQueryKeys {
  PortCollections = 'portCollections',
}

export interface PortCollectionResponse {
  count: number;
  next: string;
  previous: string;
  results: PortCollection[];
}

interface PortCollectionFilters {
  isVisible?: boolean;
  pageSize: number;
}

export async function fetchPortCollections(filters: PortCollectionFilters, signal?: AbortSignal) {
  const response: AxiosResponse<PortCollectionResponse> = await axiosWithToken.get(
    '/core/api/v1/erl/port_collections',
    {
      signal,
      params: objectKeysToSnakeCase(filters),
    }
  );
  const portCollections: PortCollectionResponse = objectKeysToCamelCase(response.data);
  return portCollections;
}
